// Sidebar Routers

export const menus = {
  "message.Modules": [{
    //action: "zmdi-accounts",
    title: "message.orderEmission",
    active: true,
    path: "/orderEmision",
    exact: true,
    permisions:['aps_broker','aps_executive','aps_promotor'],
    admin:false
  },
  {
    //action: "zmdi-case-check",
    title: "message.comissions",
    active: true,
    path: "/commission/commissionList",
    exact: true,
    validateKerygMaseg: true,
    permisions:['aps_broker'],
    admin:false    
  },
  {
    //action: "zmdi-case-check",
    title: "message.squareComission",
    active: true,
    path: "/commission/squareCommissionList",
    exact: true,
    permisions:[],
    validateKerygMaseg: true,
    admin:false    
  },
  {
    // action: "zmdi-case-check",
    title: "message.bonusProduction",
    active: true,
    path: "/bonusProduction/bonusProductionList",
    exact: true,
    permisions:['aps_broker'],
    validateKerygMaseg: true,
    admin:false  
  },
  {
    //action: "zmdi-case-check",
    title: "message.bonusCompliance",
    active: true,
    path: "/bonusCompliance/bonusComplianceList",
    exact: true,
    permisions:['aps_broker'],
    validateKerygMaseg: true,
    admin:false   

  },
    {
    //action: "zmdi-case-check",
    title: "message.bonusCategory",
    active: true,
    path: "/bonusCategory/bonusCategoryList",
    exact: true,
    permisions:['aps_broker'],
    validateKerygMaseg: true,
    admin:false   

  },
  {
    //action: "zmdi-case-check",
    title: "message.cartera",
    active: true,
    path: "/cartera/estadoCuentaTotal",
    exact: true,
    permisions:['aps_broker', 'aps_executive'],
    admin:false   
  },
  {
    //action: "zmdi-case-check",
    title: "message.reunionCartera",
    active: true,
    path: "/reunionCartera",
    exact: true,
    permisions:['aps_broker', 'aps_executive'],
    admin:false   
  },
  {
    // action: "zmdi-image",
    title: "message.images",
    path: "/images",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    admin:false
  },
  {
    // action: "zmdi-image",
    title: "message.cotizadorFianzas",
    path: "/CotizadorFianzas",
    exact: true,
    permisions:['aps_broker','aps_executive','aps_promotor'],
    admin:false
  },
  {
    //action: "zmdi-comment-dots",
    title: "message.quoting",
    path: "/quoting",
    exact: true,
    permisions:['aps_broker','aps_executive','aps_promotor'],
    admin:false
  },
  {
    //action: "zmdi-comment-dots",
    title: "Administrador Ecommerce",
    path: "/ecommerce",
    exact: true,
    cifraseg:true,
    permisions:['aps_broker','aps_executive','aps_promotor'],
    admin:false
  },
  {
    //action: "zmdi-phone-bluetooth",
    title: "message.comercial",
    active: true,
    path: "/commercial/commercialList",
    exact: true,
    permisions:['aps_broker'],
    admin:false
  
  },
  {
    //action: "zmdi-chart",
    title: "message.requestInspection",
    path: "/requestInspection",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    domains: ['@cifraseg.net.ec'],
    admin:false,
    
  },
  {
    //action: "zmdi-chart",
    title: "message.electronicDocuments",
    path: "/electronicDocuments",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    admin:false,
    
  },
  {
    //action: "zmdi-chart",
    title: "message.electronicBillings",
    path: "/electronicBilling",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    admin:false,
    
  },
  {
    //action: "zmdi-chart",
    title: "message.productionReports",
    path: "/productionReport",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    domains: ['@cifraseg.net.ec'],
    admin:false,
    
  },
  {
    //action: "zmdi-chart",
    title: "message.linkForms",
    path: "/linkForm",
    exact: true,
    permisions:['aps_broker','aps_executive'],
    admin:false,
    
  },
  ],
  "message.administration": [{
    //action: "zmdi-notifications-active",
    title: "message.notifications",
    path: "/pushNotifications",
    exact: true,
    permisions:['aps_admin'],
    admin:true
  },
    {
     //action: "zmdi-notifications-active",
      title: "message.users",
      path: "/users",
      exact: true,
      permisions:['aps_admin'],
      admin:true
    }
  ]
};